export const MERGE_ENTITIES = 'MERGE_ENTITIES';
export const UPDATE_ENTITIES = 'UPDATE_ENTITIES';
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES';
